export default (theme) => ({
    root: {
        flex: 1,
        minHeight: 0,
        '& .react-grid-Main': {
            outline: 'none',
            borderTop: `1px solid ${theme.colors.grey[100]}`,
        },
    },
});
